module.exports = `${require.publicPath}bg04.1d81bc12.png`;